import React from "react";

export default function PageHeadline({ title, fontProps = 'default', isRegistration = false }) {
    return (
        <div className="relative">
            {isRegistration ? (
                <div className="w-fit bg-white px-4 py-2 drop-shadow-2xl border-4 border-[#164481] jersey25">
                    {fontProps === 'default' ?
                        <h1 className="text-2xl md:text-7xl jersey25 font-bold uppercase text-[#164481] tracking-wider">
                            {title}
                        </h1> : <h1 className="md:text-4xl text-2xl jersey25 font-bold italic uppercase text-[#164481] tracking-wider">
                            {title}
                        </h1>}
                </div>
            ) : (
                    <div className="w-fit bg-transparent px-4 py-2 jersey25">
                        {fontProps === 'default' ?
                            <h1 className="text-2xl md:text-7xl jersey25 font-bold uppercase text-white tracking-wider">
                                {title}
                            </h1> : <h1 className="md:text-6xl text-2xl jersey25 font-bold italic uppercase text-white tracking-wider">
                                {title}
                            </h1>}
                    </div>
            )}
        </div>
    );
}
